module.exports = "pegasus_template/assets/theme2/google-icon.png";